<div class="mx-auto flex min-h-full w-full max-w-3xl flex-col pl-3 pr-4 lg:px-6 3xl:px-0">
  @if (tab() && tab()!.messages && tab()!.messages.length > 0) {
    <app-chat-messages
      class="flex-1 pb-10"
      [currentThread]="tab()"
      [activeTab]="tabService.activeTab()"
      [currentMessages]="tab()?.messages || []"
      [vehicle]="vehicle()"
      data-testid="chat-message-list" />
  } @else {
    <app-empty-chat class="flex-1 !pb-10" />
  }

  <div class="sticky bottom-4 bg-white pt-[1px]">
    @if (isLegacyThread()) {
      <div class="mb-2 flex items-start gap-3 rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
        <i class="pi pi-exclamation-triangle mt-[2px] shrink-0"></i>
        <span>{{ 'chatInput.legacyThread' | transloco }}</span>
      </div>
    } @else if (isVwLegacyThread()) {
      <div class="mb-2 flex items-start gap-3 rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
        <i class="pi pi-exclamation-triangle mt-[2px] shrink-0"></i>
        <span>{{ 'chatInput.legacyVwThread' | transloco }}</span>
      </div>
    } @else if (isDeletedThread()) {
      <div class="mb-2 flex items-start gap-3 rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">
        <i class="pi pi-exclamation-triangle mt-[2px] shrink-0"></i>
        <span>{{ 'chatInput.DeletedThread' | transloco }}</span>
      </div>
    } @else {
      <app-chat-input-suggestions [tabId]="tab()?._id">
        <app-chat-input [tabId]="tab()?._id" class="w-full" />

        <p class="flex gap-2 px-4 pb-4 pt-2 text-xs text-zinc-500" [ngClass]="{ hidden: !vehicle() || !tabService.llmAnswersOn() }">
          <i class="pi pi-exclamation-triangle mt-[1px] !text-xs"></i>
          <span class="block max-w-[950px]">
            {{ 'chatInput.aiHint' | transloco }}
          </span>
        </p>
      </app-chat-input-suggestions>
    }
  </div>
</div>
